import api from '../api'

export default {
    namespaced: true,
    state: {
        platformReportInfo: {
            //平台收取的服务费
            "collectFeeTotal" : 0,
            //投入JackPot金额
            "collectJPTotal" : 0,
            //购买表情包总额
            "buyExpression" : 0,
            // 投入跑马灯金额
            "collectHorseRaceLampTotal" : 0,
            // 延迟
            "buyDelay" : 0,
            //购买VIP总额
            "buyVip" : 0,
            //用户提现手续费总额
            "withdrawalFee" : 0,
            //AI用户赢取总额
            "aiWinTotal" : 0,
            //服务费总返佣
            "winFeeRebate" : 0,
            //保险总返佣
            "insuranceRebate" : 0,
            //JackPot中奖
            "jpUserWin" : 0,
            //JackPot总服务费
            "jpWinFee" : 0,
            //JackPot总返佣
            "jpWinRebate" : 0,
            //跑马灯中奖
            "horseRaceLampWin" : 0,
            //代理模式费用
            "agentFee" : 0,
            //AI用户输掉的积分
            "aiFailTotal" : 0,
            //保险池收益总额
            "insuranceProfitTotal" : 0,
            //保险池支出总额
            "insuranceExpenditureTotal" : 0,
            //俱乐部保险池收益总额
            "insuranceClubRebate" : 0,
            //联盟保险池收益总额
            "insuranceTribeRebate" : 0,
            //投入系统池总额
            "collectSystemTotal" : 0,
            //总输赢积分
            "winTotal" : 0,
            //总输赢积分
            "userWinTotal" : 0,
            //俱乐部用户返利总额
            "clubFeeRebate" : 0,
            //联盟用户返利总额
            "tribeFeeRebate" : 0,
            //用户充值总额
            "userRecharge" : 0,
            //用户提现总额
            "userWithdrawal" : 0,
            //德州牛仔  输赢
            "winChip":0,
            //德州牛仔  俱乐部返佣
            "clubRebateChip":0,
            //德州牛仔  联盟返佣
            "recordsRebateChip":0,
            //德州牛仔  平台对赌仓
            "adminChip":0,
            //百人德州  输赢
            "winChipBRDZ":0,
            //百人德州  俱乐部返佣
            "clubRebateChipBRDZ":0,
            //百人德州  联盟返佣
            "recordsRebateChipBRDZ":0,
            //百人德州  中彩金额
            "jackpotChipBRDZ":0,
            //百人德州  彩金池
            "jackpotSumChipBRDZ":0,
            //百人德州  抽水总金额
            "taxNumBRDZ":0,
            //百人德州  抽水比例
            "taxBRDZ":0,
        }
    },
    mutations: {
        setPlatformReportInfo(state, info) {
            state.platformReportInfo = info
        }
    },
    actions: {
        getPlatformReportInfo({commit}, params) {
            return api.post(`/data/statistics/query`, '获取平台报表信息', params).then(res => {
                commit('setPlatformReportInfo', res.data)
            })
        },
        getPromoterList(state, params) {
            return api.post(`/data/statistics/promoterList`, '推广员列表', params);
        },
        getPromoterOne(state, params) {
            return api.post(`/data/statistics/promoterOne`, '推广员详情', params);
        },
        getClubPlatformStatisticsTotal(state, params) {
            return api.post(`/data/statistics/club/platform`, '俱乐部报表', params);
        },
        getClubPlatformStatisticsOne(state, params) {
            return api.post(`/data/statistics/club/platformOne`, '俱乐部用户报表', params);
        },
        getTribePlatformStatisticsTotal(state, params) {
            return api.post(`/data/statistics/tribe/platform`, '联盟报表', params);
        },
        getTribePlatformStatisticsOne(state, params) {
            return api.post(`/data/statistics/tribe/platformOne`, '联盟报表', params);
        },
    }
}
